export const CATEGORY_PARAM = "category";
export const MUNICIPALITY_PARAM = "municipality";
export const PAGE_NUMBER_PARAM = "pageNumber";

export const FILTER_PARAMS: ReadonlyArray<string> = [
  CATEGORY_PARAM,
  MUNICIPALITY_PARAM,
  PAGE_NUMBER_PARAM,
];
